var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgExternalLink = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M19.1893398,3.75 L15,3.75 C14.5857864,3.75 14.25,3.41421356 14.25,3 C14.25,2.58578644 14.5857864,2.25 15,2.25 L21,2.25 C21.4142136,2.25 21.75,2.58578644 21.75,3 L21.75,9 C21.75,9.41421356 21.4142136,9.75 21,9.75 C20.5857864,9.75 20.25,9.41421356 20.25,9 L20.25,4.81066017 L10.5303301,14.5303301 C10.2374369,14.8232233 9.76256313,14.8232233 9.46966991,14.5303301 C9.1767767,14.2374369 9.1767767,13.7625631 9.46966991,13.4696699 L19.1893398,3.75 Z M17.25,13 C17.25,12.5857864 17.5857864,12.25 18,12.25 C18.4142136,12.25 18.75,12.5857864 18.75,13 L18.75,19 C18.75,20.5187831 17.5187831,21.75 16,21.75 L5,21.75 C3.48121694,21.75 2.25,20.5187831 2.25,19 L2.25,8 C2.25,6.48121694 3.48121694,5.25 5,5.25 L11,5.25 C11.4142136,5.25 11.75,5.58578644 11.75,6 C11.75,6.41421356 11.4142136,6.75 11,6.75 L5,6.75 C4.30964406,6.75 3.75,7.30964406 3.75,8 L3.75,19 C3.75,19.6903559 4.30964406,20.25 5,20.25 L16,20.25 C16.6903559,20.25 17.25,19.6903559 17.25,19 L17.25,13 Z"
  }));
};
export default SvgExternalLink;